import { GlobalDialogsType } from '../types';

const initialState: GlobalDialogsType = {
    loginDialog: false
};

export default initialState;
